<template>
  <div class="partial-selection d-flex">
    <div class="is-partially-invoiced" v-if="showIsPartiallySelectedIcon">
      <span>
        <!-- Show proper icon -->
        <BIconCalendar2Check
          v-if="isPartiallyScheduled"
          class="h4 partial-icon"
        />
        <BIconCashStack v-else class="h4 partial-icon" />
      </span>
    </div>
    <b-col class="mb-2" v-if="allowSelection">
      <b-form-checkbox
        :checked="isPartiallyScheduled"
        :disabled="isPartiallyInvoiced"
        @change="onChange"
      >
        {{ $t('partial-invoiced-label') }}
      </b-form-checkbox>
    </b-col>
  </div>
</template>

<script>
export const PartialStateEnum = Object.freeze({
  INVOICED: 'invoiced',
  SCHEDULED: 'scheduled',
});

import { BIconCalendar2Check, BIconCashStack } from 'bootstrap-vue';

export default {
  components: {
    BIconCalendar2Check,
    BIconCashStack,
  },
  props: {
    allowSelection: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showIsPartiallySelectedIcon() {
      return [PartialStateEnum.INVOICED, PartialStateEnum.SCHEDULED].includes(
        this.state,
      );
    },
    isPartiallyScheduled() {
      return [PartialStateEnum.SCHEDULED].includes(this.state);
    },
    isPartiallyInvoiced() {
      if (this.disabled) {
        return this.disabled;
      }
      return [PartialStateEnum.INVOICED].includes(this.state);
    },
  },
  methods: {
    onChange(isSelected) {
      this.$emit('change', isSelected);
    },
  },
};
</script>
<style scoped>
.partial-icon {
  color: #04a789;
}
</style>
